export default __webpack_public_path__ + "assets/774ff9f8a80f003266907b75e4fe71fe.png";